// ExamListPage.js
import React from "react";
import { useLocation } from "react-router-dom";
import ExamList from './ExamList/ExamList'; // adjust path as needed

const dummyExams = [
  {
    id: 1,
    title: "Math Test",
    date: "2025-07-10",
    status: "active",
  },
  {
    id: 2,
    title: "Science Quiz",
    date: "2025-06-15",
    status: "inactive",
  },
  {
    id: 3,
    title: "English Exam",
    date: "2025-08-01",
    status: "active",
  },
  // ...add more
];

const useQuery = () => new URLSearchParams(useLocation().search);

const ExamListPage = () => {
  const query = useQuery();
  const statusFilter = query.get("status"); // "active" or "inactive"

  return (
    <ExamList
      exams={dummyExams}
      title={`${statusFilter ? statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1) : "All"} Exams`}
      filterStatus={statusFilter}
    />
  );
};

export default ExamListPage;
